import Home from "../../Routes/Home.js";
// import Analysis from "../../Routes/Analysis.js";
import AnalysisRouter from "../../Routes/AnalysisRouter.js";
import Profile from "../../Routes/Profile.js";
import MyDocuments from "../../Routes/MyDocuments.js";
import Preferences from "../../Routes/Preferences.js";
import UploadIndex from "../../Routes/UploadIndex.js";


import { GoPerson, GoHomeFill, GoLog, GoUpload} from "react-icons/go";

const SideBarData =
    {
        pages: [
            {
                title: "Home",
                path: "/",
                element: <Home/>,
                icon: GoHomeFill,
                needsAuth: false,
                id: "home"
            },
            {
                title: "Upload",
                path: "/upload",
                element: <UploadIndex/>,
                icon: GoUpload,
                needsAuth: false,
                id: "uploadindex"
            },
            {
                title: "Analyze Document",
                path: `/analysis`,
                element: <AnalysisRouter/>,
                icon: GoLog,
                needsAuth: false,
                needTC: true,
                id: "analysisrouter"
            },
            {
                title: "My Documents",
                path: "/mydocuments",
                element: <MyDocuments/>,
                icon: GoLog,
                needsAuth: true,
                id: "history"
            },
            {
                title: "Profile",
                path: "/profile",
                element: <Profile/>,
                icon: GoPerson,
                needsAuth: true,
                id: "profile"
            },
            {
                title: "Preferences",
                path: "/preferences",
                element: <Preferences/>,
                icon: GoPerson,
                needsAuth: true,
                id: "preferences"
              },
        ]
    };

export default SideBarData;